"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
exports.palette = {
    primary: '#EA1D2C',
    primaryLight: '#FF7B85',
    primaryDark: '#AA000C',
    // Monochrome
    lightest: '#FCFCFC',
    lighter: '#F7F7FC',
    light: '#EFF0F6',
    mediumlight: '#D9DBE9',
    dark: '#A6A6A6',
    darker: '#717171',
    darkest: '#3E3E3E'
};
//# sourceMappingURL=palette.js.map